<template>
    <b-modal id="modal-calendar" size="size-calendar" hide-footer hide-header no-close-on-backdrop no-close-on-esc centered modal-class="modal-mobile-fullscreen" >
        <div class="d-block text-center mt-1 mt-lg-3 mb-3">
           <img :src="$store.getters['appConfig/getAppLogo']">
        </div>
        <div class="calendar-empty" v-if="events.length === 0">
          {{ $t('pages.calendar.calendar_modal_no_events') }}
        </div>
        <div class="d-block calendar-list mt-4" v-else>
          <template v-for="(ev, index) in events" >
            <div class="calendar-list__item" :key="index">
              <div class="calendar-list__item__content">
                <div class="calendar-list__item__content__date">
                  <span class="calendar-list__item__content__date__day">{{ ev.start_at.getDate() }}</span> <br>
                  <span class="calendar-list__item__content__date__month">{{ ev.start_at.toLocaleString(locale, { month: 'short' }) }}</span>
                </div>
                <div class="calendar-list__item__content__info">
                  <div class="calendar-list__item__content__info__help">
                    Serie A - {{ ev.start_at.toLocaleString(locale, { hour: 'numeric', minute:'numeric' }) }}
                  </div>
                  <div class="calendar-list__item__content__info__title">
                    {{ ev.title }}
                  </div>
                  <div class="calendar-list__item__content__info__subtitle">
                    {{ ev.subtitle }}
                  </div>
                </div>
              </div>
              <div class="calendar-list__item__btn">
                <a class="btn btn-block btn-outline-primary" :href="ev.gallery_url">
                  {{ $t('pages.calendar.calendar_modal_btn_photos') }}
                  <span class="btn-arrow">></span> </a>
              </div>
            </div>
            <hr style="margin: .7rem -1rem;" class="border-dark">
          </template>
        </div>
    </b-modal>
</template>

<script>
    export default {
        components: {
        },
        props: ['events'],
    }
</script>
